module.exports = __webpack_public_path__ + "static/media/responsive-design.e759a1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/responsive-design.png
// module id = 417
// module chunks = 1